module.exports = __webpack_public_path__ + "static/media/samnivesha.b13a374a.png";